import { render, staticRenderFns } from "./DialogLevel.vue?vue&type=template&id=5032c0b5&scoped=true&"
import script from "./DialogLevel.vue?vue&type=script&lang=js&"
export * from "./DialogLevel.vue?vue&type=script&lang=js&"
import style0 from "./DialogLevel.vue?vue&type=style&index=0&id=5032c0b5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5032c0b5",
  null
  
)

export default component.exports